export const sha256 = async (message: string) => {
   const msgBuffer = new TextEncoder().encode(message);
   const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);
   const hashArray = Array.from(new Uint8Array(hashBuffer));
   const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
   return hashHex;
}

export const abreviarIniciaisNome = (nome: string | undefined) => {
   if (!nome)
      return "";

   const regex = /([A-Za-z]).+? ([A-Za-z]).+/i;
   return nome.replace(regex, "$1$2").toUpperCase();
}

export const gerarCor = () => {
   return "hsl(" + 360 * Math.random() + ',' +
      (25 + 70 * Math.random()) + '%,' +
      (85 + 10 * Math.random()) + '%)';
}